import Box from '@mui/material/Box';
import * as React from 'react';
import _ from 'lodash';
import { useMemo } from 'react';
import PartyButton from './PartyButton';

export default function WidgetPartyButtons({ parties, disabled, onClick, sx }) {
    const shuffledParties = useMemo(() => _.shuffle(parties), [parties]);

    const getToolTipForParty = () => {
        if (disabled) {
            return 'Voer een stelling in om een party te kunnen selecteren.';
        }
        return null;
    };

    return (
        <Box
            sx={{
                ...{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    gap: '4px'
                },
                ...sx
            }}>
            {shuffledParties?.map((party, index) => {
                return (
                    <PartyButton
                        key={party.uuid}
                        disabled={disabled}
                        notAvailable={false}
                        onClick={() => onClick(party)}
                        tooltip={getToolTipForParty(party)}
                        sx={{
                            backgroundColor: 'none',
                            width: {
                                xs: '55px',
                                sm: '80px'
                            },
                            animationDelay: `${Math.round(index * 500)}ms`
                        }}
                        image={party?.logo}
                    />
                );
            })}
        </Box>
    );
}
